import {TimeRange} from '@flowmaps-com/flowmaps-typescriptmodels';

export function resolveMeasurementsTimeRange(range: TimeRange | undefined, filterRange: TimeRange): TimeRange {
    return range && Object.keys(range).length > 0 ? range : filterRange;
}
